export const VERIFICATIONFAILURE = "VERIFICATIONFAILURE"
export const VERIFICATIONSUCCESS = "VERIFICATIONSUCCESS"
export const VERIFICATIONREQUEST = "VERIFICATIONREQUEST"